import CalendarActionResponse from 'owa-service/lib/contract/CalendarActionResponse';
import { CalendarGroup } from 'owa-calendar-surface-calendars-store';
import deleteCalendarGroupOperation from 'owa-service/lib/operation/deleteCalendarGroupOperation';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import { MailboxInfo } from 'owa-client-ids';

/**
 * Creates a calendar group on server
 * @param The calendar group to create
 * @returns The response with the created group's id
 */
export default function deleteCalendarGroupService(
    group: CalendarGroup,
    mailboxInfo: MailboxInfo
): Promise<CalendarActionResponse> {
    return deleteCalendarGroupOperation(
        {
            groupId: group.id.id,
        },
        getMailboxRequestOptions(mailboxInfo)
    );
}
